import axiosNew from '../../../helpers/axios'

// LIST TASKS FOR SUPPORT
export const listTask = (payload) => {
    const {
        skip = 0,
        limit = 10,
        filter,
        search = '',
        listType = 'status',
    } = payload
    return new Promise(async (resolve) => {
        try {
            let data = {
                skip,
                limit,
                filter,
                listType: listType,
            }
            if (search?.length > 0) {
                data['search'] = {
                    title: search,
                }
            }
            const tasks = await axiosNew({
                url: 'support/task/list-app',
                data,
            })
            resolve({
                data: tasks?.data?.data ?? tasks?.data?.result ?? [],
                isNext: tasks?.data?.isNext ?? false,
            })
        } catch (error) {
            resolve({ data: [] })
        }
    })
}

// GET SUPPORT TASK BY ID
export const getSupportTaskById = async (payload) => {
    return new Promise(async (resolve) => {
        try {
            const getTask = await axiosNew({
                url: `support/task/${payload._id}/app`,
                method: 'get',
            })
            resolve({ data: getTask?.data ?? {} })
        } catch (error) {
            resolve({ data: error?.response?.data ?? {} })
        }
    })
}

// LIST SUB TASKS FOR SUPPORT
export const listSupportSubTasks = (payload) => {
    const { skip = 0, limit = 10, parentId } = payload
    return new Promise(async (resolve) => {
        try {
            let data = {
                skip,
                limit,
                parentId,
            }
            const tasks = await axiosNew({
                url: 'support/task/child-list-app',
                data,
            })
            resolve({ data: tasks?.data?.data ?? [] })
        } catch (error) {
            resolve({ data: [] })
        }
    })
}

// ADD / REMOVE COMMENTS FOR SUPPORT
export const addRemoveSupportComments = async (payload) => {
    return new Promise(async (resolve) => {
        try {
            let data = payload?.data ?? {}
            const addRemoveComments = await axiosNew({
                url: `support/task/add-remove-comments/${payload.id}/app`,
                data,
                method: 'put',
            })
            resolve({ data: addRemoveComments.data ?? {} })
        } catch (error) {
            resolve({ data: error?.response?.data ?? {} })
        }
    })
}

// ADD / REMOVE ATTACHMENTS
export const supportTaskHistory = async (id) => {
    return new Promise(async (resolve) => {
        try {
            const taskHistoryData = await axiosNew({
                url: `support/task/history/${id}/app`,
                method: 'get',
            })
            resolve({ data: taskHistoryData.data ?? {} })
        } catch (error) {
            resolve({ data: error?.response?.data ?? {} })
        }
    })
}
